var translations = {
    pl: {
        list: "Obiekty",
        people: "Osoby",
        bibliography: "Bibliografia",
        search: "Szukaj",
        historicAddresses: "Adresy historyczne",
        constructionYear: "Rok budowy",
        architect: "Architekt",
        investor: "Inwestor",
        searchResult: "Wyniki wyszukiwania",
        cityMap: "Plan miasta",
        aboutProject: "O projekcie",
        education: "Edukacja"
    },
    de: {
        list: "Objekte",
        people: "Personen",
        bibliography: "Bibliographie",
        search: "Suchen",
        historicAddresses: "Historische Adressen",
        constructionYear: "Baujahr",
        architect: "Architekt",
        investor: "Bauherr",
        searchResult: "Die Ergebnisse der Suche",
        cityMap: "Stadtplan",
        aboutProject: "Über das Projekt",
        education: "Bildung"
    }
}

var language = "pl";
if (localStorage.language) {
    language = localStorage.getItem('language');
}

const localization = {
    l:language,
    changeLang: (lang) => {
        localization.dictionary = translations[lang];
        localStorage.setItem('language', lang);
        localization.l = lang;

    },
    getLang: function () {
        return localization.l;
    },
    normalizeString:function(data){
        let string_norm = data.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace("ł","l").replace("Ł","L");
        return string_norm;
    },
    dictionary: translations[language],
}

localization.install = function (Vue) {
    Vue.observable(localization);
    Vue.prototype.$localization = localization;
    Vue.prototype.$t = (word) => localization.dictionary[word];
    Vue.prototype.$lang = () => localization.l;
}

export default localization;